import { inheritsLoose as _inheritsLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Products.module.scss.js';
import SubscriptionCard from '@piconetworks/pkg-field-select-subscription';
import PassCard from '@piconetworks/pkg-field-select-pass';
import TrialCard from '@piconetworks/pkg-field-select-trial';
import DonationCard from '@piconetworks/pkg-field-select-donation';
import { Form } from 'react-final-form';
import { SUBSCRIPTION_TYPE, PASS_TYPE, TRIAL_TYPE, PLEDGE_TYPE, DONATION_SUGGESTIONS } from '../utils/constants/productEdit.js';

var _CARD;
var CARD = (_CARD = {}, _CARD[SUBSCRIPTION_TYPE] = /*#__PURE__*/React.createElement(SubscriptionCard, null), _CARD[PASS_TYPE] = /*#__PURE__*/React.createElement(PassCard, null), _CARD[TRIAL_TYPE] = /*#__PURE__*/React.createElement(TrialCard, null), _CARD[PLEDGE_TYPE] = /*#__PURE__*/React.createElement(SubscriptionCard, null), _CARD[DONATION_SUGGESTIONS] = /*#__PURE__*/React.createElement(DonationCard, null), _CARD);
var ProductPreviewCard = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ProductPreviewCard, _React$PureComponent);
  function ProductPreviewCard() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.renderCardType = function () {
      var _cx, _product$custom_text;
      var type;
      var _this$props = _this.props,
        contributionLanguage = _this$props.contributionLanguage,
        product = _this$props.product,
        selectedProductId = _this$props.selectedProductId,
        previewMode = _this$props.previewMode;
      if (product.pledge_mode) {
        type = 'pledge';
      } else if (product.options[0].trial_quantity) {
        type = 'trial';
      } else {
        type = product.type;
      }
      return CARD[type] && /*#__PURE__*/React.cloneElement(CARD[type], {
        contributionLanguage: contributionLanguage,
        product: product,
        name: product.type,
        className: !previewMode ? cx(styles.dashed, (_cx = {}, _cx[styles.selected] = product.id === selectedProductId, _cx)) : undefined,
        linkColor: '#000',
        customFeaturesUrl: product === null || product === void 0 ? void 0 : (_product$custom_text = product.custom_text) === null || _product$custom_text === void 0 ? void 0 : _product$custom_text.filename
      });
    };
    return _this;
  }
  var _proto = ProductPreviewCard.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      product = _this$props2.product,
      handleProduct = _this$props2.handleProduct;
    return /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return handleProduct(product.id);
      }
    }, /*#__PURE__*/React.createElement(Form, {
      initialValues: product,
      onSubmit: function onSubmit() {},
      render: function render() {
        return _this2.renderCardType();
      }
    }));
  };
  return ProductPreviewCard;
}(React.PureComponent);
ProductPreviewCard.defaultProps = {
  handleProduct: function handleProduct() {}
};
ProductPreviewCard.propTypes = {
  contributionLanguage: PropTypes.string,
  handleProduct: PropTypes.func,
  previewMode: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  product: PropTypes.object,
  selectedProductId: PropTypes.string
};

export { ProductPreviewCard as default };
//# sourceMappingURL=ProductPreviewCard.js.map
